export const API_URL = {
  GETWAY_API: process.env.REACT_APP_GETWAY_API,
  COMMON_GATEWAY_API: process.env.REACT_APP_GETWAY_API,
};

export const API_KEY = "price-d77bctr90f-68fghy-47caltda-94c2-op30de83aawe";

const currentYear = new Date().getFullYear();

export const MAX_YEAR = currentYear - 15;